import { useEffect, useState } from 'react';

const useMinDwell = <T>(liveValue: T, dwellValue: T, minDwellMs: number): T => {
  const [dwellEndsAt, setDwellEndsAt] = useState<number | null>(() =>
    liveValue === dwellValue ? Date.now() + minDwellMs : null,
  );

  useEffect(() => {
    if (liveValue === dwellValue && dwellEndsAt === null) {
      setDwellEndsAt(Date.now() + minDwellMs);
    }
  }, [liveValue, dwellValue, minDwellMs, dwellEndsAt]);

  useEffect(() => {
    if (dwellEndsAt === null) return undefined;
    const remaining = dwellEndsAt - Date.now();
    if (remaining <= 0) {
      setDwellEndsAt(null);
      return undefined;
    }
    const handle = setTimeout(() => setDwellEndsAt(null), remaining);
    return () => clearTimeout(handle);
  }, [dwellEndsAt]);

  return dwellEndsAt !== null ? dwellValue : liveValue;
};

export default useMinDwell;
